import { getPost, getPostList } from '../../api/post';
import UTILS from '../../utils/utils';

export const post = {
  strict: true, // true => strict update state from component

  state: {
    loading: false,
    refreshedAt: 0,
    lastRefreshingId: 0,
    lastRefreshedId: 0,
    postUpdatedTime: 0,
    todoCount: {},
    /*
      {
        code:'NS'|'FL'|'SD'|'EQ'|'LF',
        cid:number, ... (initial selected community id on create new)
        members:string[], ... 'm123','g123','A1' (initial selected member on create new)
        pid:number. ... 0 or 1~
      }
    */
    dialog: null,
  },

  getters: {},

  mutations: {
    POST_LOADING: (state, loading) => {
      state.loading = loading;
    },
    POST_UPDATE_REFRESH: (state, id) => {
      state.refreshedAt = new Date().getTime();
    },
    POST_SET_LAST_REFRESHING_ID: (state, id) => {
      state.lastRefreshingId = id;
    },
    POST_SET_LAST_REFRESHED_ID: (state, id) => {
      state.lastRefreshedId = id;
    },
    POST_SET_UPDATED_AT: (state, at) => {
      state.postUpdatedTime = at;
    },
    POST_COUNT_TODO: (state, posts) => {
      var cs = {};
      for (var post of posts) {
        if (UTILS.isPostCompleted(post)) continue;
        var cid = post.community_id;
        cs[cid] = cs[cid] ? cs[cid] + 1 : 1;
      }
      state.todoCount = cs;
    },
    POST_EDIT_DIALOG_OPEN: (state, content) => {
      state.dialog = content;
    },
    POST_EDIT_DIALOG_CLOSE: state => {
      state.dialog = null;
    },
  },

  actions: {
    refreshPostById({ state, commit, rootState }, id, force) {
      if (!id) return console.error(`invalid pid=${id}`);
      if (!force && state.lastRefreshingId == id) return;
      commit('POST_SET_LAST_REFRESHING_ID', id);

      getPost(id)
        .then(function(post) {
          if (!post) return;
          $commin.clientdb.getObject('posts', function(posts) {
            // if no data incache, do nothing.
            posts = UTILS.mergePost(posts, post);
            $commin.clientdb.putObject('posts', posts);
            commit('POST_SET_LAST_REFRESHED_ID', 0);
            commit('POST_SET_LAST_REFRESHING_ID', 0);
            commit('POST_UPDATE_REFRESH');
            commit('POST_COUNT_TODO', posts);
          });
        })
        .catch(function(e) {
          console.error(`failed to get post ${id} data`, e);
          if (e.error_code == 1001) {
            // unauthorized
            $commin.clientdb.getObject('posts', function(posts) {
              // if no data incache, do nothing.
              posts = UTILS.removePost(posts, id);
              $commin.clientdb.putObject('posts', posts);
              commit('POST_SET_LAST_REFRESHED_ID', 0);
              commit('POST_SET_LAST_REFRESHING_ID', 0);
              commit('POST_UPDATE_REFRESH');
              commit('POST_COUNT_TODO', posts);
            });
          }
        });
    },
    refreshPost({ state, commit, rootState }, at, cb, force) {
      if (!force) {
        if (state.loading) return;
        commit('POST_LOADING', true);

        if (at) {
          // already requested!
          if (state.postUpdatedTime == at) return commit('POST_LOADING', false);
          commit('POST_SET_UPDATED_AT', at);
        }
      }
      console.log('refresh posts');

      // get from server (just save to clientdb)
      getPostList(0)
        .then(function(response) {
          var ps = response || [];
          if (cb) cb(ps);
          $commin.clientdb.putObject('posts', ps);
          commit('POST_UPDATE_REFRESH');
          commit('POST_COUNT_TODO', ps);
          if (!force) commit('POST_LOADING', false);
        })
        .catch(function(e) {
          console.error('failed to get posts data', e);
          if (!force) commit('POST_LOADING', false);
        });
    },
  },
};
